import React from 'react';
import { useModalClose } from '../../../../utils/useModalClose';
import { DeliveryOrderService } from '../../../../services/delivery-order.service';
import { AlertService } from '../../../../services/alert.service';

type Props = {
  close: () => void;
  reject: () => void;
  deliveryOrder: {
    id: string;
  };
};

export const RevertReceivedInRussiaConfirmationModal: React.FC<Props> = ({
  deliveryOrder,
  close,
  reject,
}) => {
  const modalRef = useModalClose(reject);

  return (
    <div className="modal-dialog" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-body">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3>Подтвердите действие</h3>
          </div>
          <div>После подтверждения, доставка вернется на статус "В пути"</div>
        </div>
        <div className="modal-footer justify-content-end">
          <button
            type="button"
            className="btn btn-success"
            onClick={() => {
              DeliveryOrderService.revertReceivedInRussia(
                deliveryOrder.id,
              ).then(() => {
                AlertService.success();
                close();
              });
            }}
          >
            Подтвердить
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary color-gray-600"
            onClick={() => {
              close();
            }}
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};
